import { Action, createAction } from 'redux-actions';

export const SET_CURRENT_LEG = 'SET_CURRENT_LEG';
export const GO_TO_NEXT_LEG = 'GO_TO_NEXT_LEG';

export type CurrentLegAction = Action<number>;

export const setCurrentLeg = createAction(SET_CURRENT_LEG, (legId: number) => legId);
export const goToNextLeg = createAction(GO_TO_NEXT_LEG);
